module.exports = __webpack_public_path__ + "media/scen.ad6fc7c8.webm";